import InternalContainer from '../../layout/containers/Internal';
import Box from '../../../common/components/Box/Box';

import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import getIncludedResource from '../../../helpers/getIncludedResource';
import { actions as productActions } from '../redux/ProductReducer';
import SchemeAuditList from '../components/SchemesAudit/SchemesAudit';
import { getSchemeIds } from '../helpers/getSchemeIds';

const InsurerSchemeAuditContainer = ({ params, getProduct, getInsurer }) => {
  const { insurerId, productId } = params;
  const isSchemeGroup = ['FreeSpirit', 'Free2Travel'].includes(insurerId);

  const { product, insurer } = useSelector((state) => state.productManagement);

  const currentProductId = product?.data?.id;
  const currentInsurerId = insurer?.data?.id;

  useEffect(
    () => {
      if (!currentProductId || currentProductId !== productId) {
        getProduct(productId);
      }
    },
    [productId, currentProductId, getProduct],
  );

  useEffect(
    () => {
      if (!currentInsurerId || currentInsurerId !== insurerId) {
        getInsurer(insurerId, ['schemes', 'schemes.scheme_group', 'documents']);
      }
    },
    [currentInsurerId, insurerId, getInsurer],
  );

  const schemes = getIncludedResource(insurer?.data, insurer?.included, 'schemes');
  const schemeIds = getSchemeIds(schemes, isSchemeGroup, insurer?.included);

  return (
    <InternalContainer title={'Audit'}>
      <Box>{!!schemeIds.length && <SchemeAuditList schemeIds={schemeIds} />}</Box>
    </InternalContainer>
  );
};

export default connect(
  null,
  {
    getProduct: productActions.getProduct,
    getInsurer: productActions.getInsurer,
  },
)(InsurerSchemeAuditContainer);
